import { inject } from '@angular/core'
import { AuthenticationService } from 'app/services/auth.service'
import { environment } from '../../../../environments/environment'
import {
  type ModelName,
  type ModelPropsMap,
  type ModelProps,
  type BaseModelProps,
  type ModelResponse,
  RequestMethods,
  executeModel,
} from '@carto/ps-services'

export type CartoClient = ReturnType<typeof injectCartoClient>

export function injectCartoClient() {
  const auth = inject(AuthenticationService)

  return {
    async query<T, M extends ModelName = ModelName>(options: {
      source: BaseModelProps
      params: M extends keyof ModelPropsMap ? ModelPropsMap[M] : ModelProps
      model?: M
      method?: 'GET' | 'POST'
      connection?: string
      baseUrl?: string
      signal?: AbortSignal
    }): Promise<ModelResponse<T>> {
      const accessToken = await auth.getAccessToken()

      try {
        return await executeModel<T>({
          accessToken,
          apiVersion: 'v3',
          connection: options.connection ?? environment.CARTO_CONNECTION,
          baseUrl: options.baseUrl ?? environment.API_BASE_URL,
          model: options.model ?? 'table',
          source: {
            type: 'query',
            ...options.source,
          },
          params: {
            ...options.params,
            limit: 0,
          },
          method: options.method ?? RequestMethods.get,
          fetcherOptions: {
            ...(options.signal ? { signal: options.signal } : {}),
          },
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('CARTO query failed:', error)
        throw error
      }
    },
  }
}
